import SuggestionsList from './suggestions-list';
import "./suggestions-list.less";

export default SuggestionsList;
